// regex for @[<anything>](<anything>)
export const AGENT_TAG_REGEX = /@\[[^\]]+]\([^)]+\)/g;
